/**
 * Detects URLs that are known brand logos or generic placeholders
 * scraped accidentally as event images. These should NOT be shown as event hero.
 *
 * NOTE: the proper fix is scraper-level (skip brand logos at extraction).
 * This is a frontend pragmatic guard while the scraper is fixed.
 */
const PLACEHOLDER_PATTERNS: RegExp[] = [
  /mentelocale\.it\/repository\/files\//i,
  // Add more known placeholder/logo URL patterns here as they emerge
];

export function isPlaceholderImage(url?: string | null): boolean {
  if (!url) return true;
  return PLACEHOLDER_PATTERNS.some((p) => p.test(url));
}

export function hasRealImage(event: { imageUrl?: string | null }): boolean {
  return !!event.imageUrl && !isPlaceholderImage(event.imageUrl);
}
